var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Models',{attrs:{"rounds":_vm.searchRounds},on:{"gamestate":_vm.quit,"found":_vm.emitFoundModels}}),_c('DropZone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }